"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionForm = void 0;
const T = __importStar(require("@microsoft/fast-element"));
const fast_element_1 = require("@microsoft/fast-element");
require("./template.html");
const client_1 = require("@rws-framework/client");
//@ts-ignore                
let rwsTemplate = T.html `<template>
  <div class="question-form">
    <div class="card">
      <div class="card-body">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="questionTitle">${'question.form.title.label'.t()}</label>
            <input 
              type="text" 
              id="questionTitle"
              class="form-control" 
              :value="${x => x.questionData.title}"
              @input="${(x, c) => x.updateField('title', c.event.target.value)}"
              @blur="${x => x.emitQuestionChange()}"
              placeholder="${'question.form.title.placeholder'.t()}" 
              required>
          </div>
          <div class="form-group col-md-3">
            <label for="questionType">${'question.form.type.label'.t()}</label>
            <select 
              id="questionType"
              class="form-control" 
              :value="${x => x.questionData.type}"
              @change="${(x, c) => x.updateField('type', c.event.target.value)}">
              <option value="">${'question.form.type.placeholder'.t()}</option>
              ${(0, fast_element_1.repeat)(x => x.questionTypes, (0, fast_element_1.html) `
                <option 
                  :value="${x => x.value}" 
                  ?selected="${(x, c) => c.parent.questionData.type === x.value}">
                  ${x => x.label}
                </option>
              `)}
            </select>
          </div>
          <div class="form-group col-md-3">
            <label>&nbsp;</label>
            <div class="form-check mt-2">
              <input 
                type="checkbox" 
                id="questionRequired"
                class="form-check-input" 
                :checked="${x => x.questionData.required}"
                @change="${(x, c) => x.updateField('required', c.event.target.checked)}">
              <label class="form-check-label" for="questionRequired">${'question.form.required.label'.t()}</label>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label for="questionDescription">${'question.form.description.label'.t()}</label>
          <textarea 
            id="questionDescription"
            class="form-control" 
            rows="2"
            :value="${x => x.questionData.description || ''}"
            @input="${(x, c) => x.updateField('description', c.event.target.value)}"
            placeholder="${'question.form.description.placeholder'.t()}"></textarea>
        </div>

        
        ${(0, fast_element_1.when)(x => x.questionNeedsOptions(x.questionData.type), (0, fast_element_1.html) `
          <div class="options-section">
            <div class="d-flex justify-content-between align-items-center mb-2">
              <label class="mb-0">${'question.form.options.label'.t()}</label>
              <div class="d-flex flex-column align-items-end">
                <button 
                  @click="${x => x.addOption()}" 
                  type="button" 
                  class="btn btn-sm btn-outline-primary">
                  <i class="simple-icon-plus"></i> ${'question.form.options.add'.t()}
                </button>
              </div>
            </div>
            
            ${(0, fast_element_1.repeat)(x => x.optionEntries || [], (0, fast_element_1.html) `
              <div class="option-row mb-2">
                <div class="form-row">
                  <div class="form-group col-md-5 mb-2">
                    <input 
                      type="text" 
                      class="form-control form-control-sm" 
                      :value="${(x, c) => c.parent.getOptionValue(c.index)}"
                      @input="${(x, c) => c.parent.updateOption(c.index, 'value', c.event.target.value)}"
                      placeholder="${'question.form.option.value.placeholder'.t()}">
                  </div>
                  <div class="form-group col-md-5 mb-2">
                    <input 
                      type="text" 
                      class="form-control form-control-sm" 
                      :value="${(x, c) => c.parent.getOptionLabel(c.index)}"
                      @input="${(x, c) => c.parent.updateOption(c.index, 'label', c.event.target.value)}"
                      placeholder="${'question.form.option.label.placeholder'.t()}">
                  </div>
                  <div class="form-group col-md-2 mb-2">
                    <button 
                      @click="${(x, c) => c.parent.removeOption(c.index)}" 
                      type="button" 
                      class="btn btn-sm btn-outline-danger w-100"
                      title="${'question.form.option.remove'.t()}">
                      <i class="simple-icon-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            `, { positioning: true })}
            
            ${(0, fast_element_1.when)(x => !x.optionEntries || x.optionEntries.length === 0, (0, fast_element_1.html) `
              <div class="text-muted text-center py-2">
                ${'question.form.options.empty'.t()}
              </div>
            `)}
          </div>
        `)}
      </div>
    </div>
  </div>
</template>`;
require("./styles/layout.scss");
const styles = T.css `.question-form .card {
  border: 1px solid #dee2e6;
  border-radius: 0.375rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
}
.question-form .card-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
  padding: 0.75rem 1.25rem;
}
.question-form .card-header h5 {
  color: #495057;
  font-weight: 600;
}
.question-form .card-body {
  padding: 1.5rem;
}
.question-form .options-section {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 0.375rem;
  border: 1px solid #e9ecef;
}
.question-form .options-section .option-row .form-group {
  margin-bottom: 0;
}
.question-form .form-actions {
  border-top: 1px solid #dee2e6;
  padding-top: 1rem;
  margin-top: 1rem;
}
.question-form .form-control.form-control-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  border-radius: 0.2rem;
}
.question-form .form-control:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}
.question-form .form-check-input:checked {
  background-color: #007bff;
  border-color: #007bff;
}
.question-form .form-check-input:focus {
  border-color: #80bdff;
  outline: 0;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}`;
const shadowOptions = { "mode": "open" };
let QuestionForm = class QuestionForm extends client_1.RWSViewComponent {
    constructor() {
        super(...arguments);
        this.key = 0;
        this.questionData = {
            title: '',
            description: '',
            type: 'text',
            options: [],
            required: false,
            order: 1
        };
        // Manage options as entries exactly like questions are managed in step
        this.optionEntries = [];
        // Track if we've already filled from the initial value to avoid rebinding
        this._hasInitializedFromValue = false;
        this.questionTypes = [
            { value: 'text', label: 'question.type.text'.t() },
            { value: 'textarea', label: 'question.type.textarea'.t() },
            { value: 'select', label: 'question.type.select'.t() },
            { value: 'radio', label: 'question.type.radio'.t() },
            { value: 'checkbox', label: 'question.type.checkbox'.t() },
            { value: 'number', label: 'question.type.number'.t() },
            { value: 'email', label: 'question.type.email'.t() },
            { value: 'url', label: 'question.type.url'.t() },
            { value: 'date', label: 'question.type.date'.t() }
        ];
    }
    connectedCallback() {
        super.connectedCallback();
        this.ensureQuestionData();
        // If this is a new question (no value from parent), emit initial change
        if (!this.value) {
            // Delay emission to ensure the component is fully connected
            setTimeout(() => {
                this.emitQuestionChange();
            }, 10);
        }
    }
    valueChanged(oldValue, newValue) {
        // Only fill data once when we receive questions from parent
        if (newValue && !this._hasInitializedFromValue) {
            // Create a deep copy to avoid binding issues
            this.questionData = {
                title: newValue.title || '',
                description: newValue.description || '',
                type: newValue.type || 'text',
                options: [], // Don't set options here, handle them separately
                required: newValue.required || false,
                order: newValue.order || this.key + 1,
                id: newValue.id
            };
            // Initialize option entries exactly like questions are initialized in step
            this.optionEntries = (newValue.options || []).map((option, index) => ({
                order: index,
                data: {
                    value: option.value || '',
                    label: option.label || ''
                }
            }));
            this._hasInitializedFromValue = true;
        }
    }
    ensureQuestionData() {
        if (!this.questionData || !this.questionData.title) {
            this.questionData = {
                title: '',
                description: '',
                type: 'text',
                options: [],
                required: false,
                order: this.key
            };
            this.optionEntries = [];
            this._hasInitializedFromValue = false;
        }
    }
    emitQuestionChange() {
        // Create clean options from option entries - exactly like step form does with questions
        const cleanOptions = this.optionEntries
            .filter(optionEntry => optionEntry.data &&
            (optionEntry.data.value.trim() || optionEntry.data.label.trim()))
            .map(optionEntry => ({
            value: optionEntry.data.value,
            label: optionEntry.data.label
        }));
        // Update internal question data with current options
        this.questionData = {
            ...this.questionData,
            options: cleanOptions
        };
        // Create a deep copy of the question to avoid reference issues
        const questionCopy = {
            title: this.questionData.title,
            description: this.questionData.description,
            type: this.questionData.type,
            options: cleanOptions,
            required: this.questionData.required,
            order: this.questionData.order,
            id: this.questionData.id
        };
        // Emit the deep copied question data to parent with index
        this.dispatchEvent(new CustomEvent('question-changed', {
            detail: {
                question: questionCopy,
                index: this.key,
                optionsCount: cleanOptions.length,
                hasOptions: cleanOptions.length > 0
            },
            bubbles: true
        }));
    }
    addOption() {
        // Add new option entry with proper indexing - exactly like step form does with questions
        const newOrder = this.optionEntries.length;
        const newOptionEntry = {
            order: newOrder,
            data: null // Start with null, will be filled when user types
        };
        this.optionEntries = [...this.optionEntries, newOptionEntry];
        // Don't emit change immediately when adding option
        // Let user fill it in first, change will be emitted when option changes
    }
    removeOption(index) {
        if (this.optionEntries.length > index) {
            // Remove option entry and reorder properly - exactly like step form does with questions
            const updatedOptionEntries = [...this.optionEntries];
            updatedOptionEntries.splice(index, 1);
            // Reorder remaining option entries with proper indexing
            updatedOptionEntries.forEach((optionEntry, i) => {
                optionEntry.order = i;
            });
            this.optionEntries = updatedOptionEntries;
            this.emitQuestionChange();
        }
    }
    updateField(field, value) {
        // Create a completely new object to trigger reactivity
        const updatedQuestion = { ...this.questionData };
        updatedQuestion[field] = value;
        // If changing type to an option type, ensure options array exists
        if (field === 'type' && this.questionNeedsOptions(value)) {
            if (!this.optionEntries || this.optionEntries.length === 0) {
                this.optionEntries = [
                    { order: 0, data: null }
                ];
            }
        }
        // If changing type to a non-option type, clear options
        else if (field === 'type' && !this.questionNeedsOptions(value)) {
            this.optionEntries = [];
        }
        this.questionData = updatedQuestion;
        this.emitQuestionChange();
    }
    // Handle option changes through direct entry updates - like step form does with question changes
    handleOptionChanged(index, field, value) {
        // Ensure the option entry exists
        if (index >= this.optionEntries.length) {
            return;
        }
        // Get or create the option data
        let optionData = this.optionEntries[index].data;
        if (!optionData) {
            optionData = { value: '', label: '' };
        }
        // Update the specific field
        const updatedOptionData = {
            ...optionData,
            [field]: value
        };
        // Create new option entries array to trigger reactivity - exactly like step form does
        const updatedOptionEntries = this.optionEntries.map((entry, i) => {
            if (i === index) {
                return {
                    order: entry.order,
                    data: updatedOptionData
                };
            }
            return { ...entry }; // Deep copy other entries too
        });
        this.optionEntries = updatedOptionEntries;
    }
    updateOption(index, field, value) {
        this.handleOptionChanged(index, field, value);
        // Emit change immediately when updating options
        this.emitQuestionChange();
    }
    // Helper methods to get specific option values from entry data
    getOptionValue(index) {
        const entry = this.optionEntries[index];
        return entry && entry.data ? entry.data.value : '';
    }
    getOptionLabel(index) {
        const entry = this.optionEntries[index];
        return entry && entry.data ? entry.data.label : '';
    }
    questionNeedsOptions(type) {
        return type === 'select' || type === 'radio' || type === 'checkbox';
    }
};
exports.QuestionForm = QuestionForm;
__decorate([
    client_1.observable,
    __metadata("design:type", Number)
], QuestionForm.prototype, "key", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], QuestionForm.prototype, "value", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], QuestionForm.prototype, "questionData", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Array)
], QuestionForm.prototype, "optionEntries", void 0);
__decorate([
    client_1.observable,
    __metadata("design:type", Object)
], QuestionForm.prototype, "questionTypes", void 0);
exports.QuestionForm = QuestionForm = __decorate([
    (0, client_1.RWSView)('question-form', null, { template: rwsTemplate, styles, options: { shadowOptions } })
], QuestionForm);
QuestionForm.defineComponent();
